import * as React from "react";
import GeneralSelect from "../../general_select";
import PopDetail from "../../popdetail";
import {ProjectsService} from "../../../service/v1/projects";
import GridLayout from "react-grid-layout";
import map_image from "../../../resources/img/login_bg2.png";
import SecondLayer from "../../container/second_layer";
import ProjectContainer from "./project_container";
import Wait from "../../wait";
import {SpatialService} from "../../../service/v1/spatial";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import ReactDOM from "react-dom";
import uncheck from "../../../resources/img/checkbox/checkbox_unchecked.png";

export default class LandUsesPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            project_type: {value: 0},
            description: '',
            zoneOptions: {endpoint: 'localities/list', value: 'id', label: 'name', placeholder: 'Select Zone'},
            regionOptions: {endpoint: 'localities/list', value: 'id', label: 'name', placeholder: 'Select Region'},
            districtOptions: {
                endpoint: 'localities/list',
                value: 'id',
                label: 'name',
                placeholder: 'Select District'
            },
            wardOptions: {
                endpoint: 'localities/list',
                value: 'id',
                label: 'name',
                placeholder: 'Select Ward'
            },
            villageOptions: {
                endpoint: `localities/list`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Village'
            },
            landUsesOptions: {
                endpoint: `setup/land-uses`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Land Use'
            },
            is_village: 'none',
            is_ward: 'none',
            is_district: 'none',
            is_regional: 'none',
            is_zonal: 'none',
            is_village_multi: true,
            is_ward_multi: true,
            is_district_multi: true,
            is_regional_multi: true,
            is_zonal_multi: true,
            is_village_disabled: true,
            is_ward_disabled: true,
            is_district_disabled: true,
            is_regional_disabled: true,
            locality: '',
            modules: [],
            landuse: [], totalPages: 1,
            next: null,
            previous: null,
            pageSize: 20,
        }

        this.submit = this.submit.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.generalSelect = this.generalSelect.bind(this)
        LandUsesPane.self = this
        LandUsesPane.loadData = LandUsesPane.loadData.bind(this)
        LandUsesPane.getSeries = LandUsesPane.getSeries.bind(this)
    }

    componentDidMount() {
        LandUsesPane.loadData()
    }

    static loadData() {
        try {
            Wait.show('Loading...')
            SpatialService.fetchLandUses().then(r => {
                Wait.dismiss()
                try {
                    let modules = []
                    r.data.results.forEach(d => modules.push(d))
                    console.log(r.data)
                    LandUsesPane.self.setState({
                        modules: [...modules],
                        nationalOptionBar: LandUsesPane.getSeries(modules)
                    })
                } catch (e) {
                    console.log(e)
                }

            })

        } catch (e) {
            console.log(e)
        }
    }

    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})

        console.log(e.target.name)

        if (e.target.name === 'project') {
            if (e.target.value === 'existing') {
                this.setState({
                    is_new: 'table-row'
                })
            } else {
                this.setState({
                    is_new: 'none'
                })
            }
        }
    }

    generalSelect(data, name) {
        this.setState({
            [name]: data
        })
        console.log(this.state[name])
        console.log("dv : " + data.value)
        let ids = []

        switch (name) {
            case 'zone':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_regional_disabled: false,
                    regionOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Region'
                    }
                })
                break;
            case 'region':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_district_disabled: false,
                    districtOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('district_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select District'
                    }
                })
                break
            case 'district':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_ward_disabled: false,
                    wardOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('ward_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Ward'
                    }
                })
                break
            case 'ward':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_village_disabled: false,
                    villageOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('village_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Village'
                    }
                })
                break
            case 'project_existence':
                if (data.value === 'existing') {
                    this.setState({
                        is_new: 'table-row'
                    })
                } else {
                    this.setState({
                        is_new: 'none'
                    })
                }

                break

            case 'project_list':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                    this.setState({
                        villageOptions: {
                            endpoint: `projects/list`,
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Project'
                        }
                    })
                }
                break
            case 'project_type':
                if (data.label.toString().includes('Village') || data.label.toString().includes('CCRO')
                    || data.label.toString().toLowerCase().includes('formal')) {
                    this.setState({
                        is_village: 'table-row',
                        is_ward: 'table-row',
                        is_district: 'table-row',
                        is_ward_multi: false,
                        is_district_multi: false,
                        is_regional_multi: false,
                        is_regional: 'table-row',
                        is_zonal: 'none',
                        regionOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Region'
                        },
                        is_regional_disabled: false,
                        locality: 'Village'
                    })
                }
                if (data.label.toString().includes('District')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'table-row',
                        is_regional: 'table-row',
                        is_regional_multi: false,
                        is_zonal: 'none',
                        regionOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Region'
                        },
                        is_regional_disabled: false,
                        locality: 'District'
                    })
                }
                if (data.label.toString().includes('Region')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'table-row',
                        is_zonal: 'table-row',
                        is_zonal_multi: false,
                        locality: 'Regional'
                    })
                }
                if (data.label.toString().includes('Zon')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'none',
                        is_zonal: 'table-row',
                        locality: 'Zonal',
                        zoneOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('zonal_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Zone'
                        },
                    })
                }
                if (data.label.toString().includes('Monitor')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'none',
                        is_zonal: 'table-row',
                        locality: 'Monitoring',
                        zoneOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('zonal_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Zone'
                        },
                    })
                }
                if (data.label.toString().includes('Nation')) {
                    this.setState({
                        locality: 'National',
                    })
                }
                break
        }
    }

    render() {

        return (<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding: 0, height: '100vh', overflow: "auto"}}>

                <div className={'row'} style={{margin: '16px'}}>
                    <div className={'col col-sm-12'}>
                        <div className={'ucard'} style={{borderBottom: '2px solid darkcyan', height: 'fit-content'}}
                             id={'high-chart-bar'}>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={this.state.nationalOptionBar}
                            />
                        </div>
                    </div>
                </div>


                <table style={{width: '94%', margin: '2%', zIndex: '2000'}}>
                    <tbody>
                    <tr>
                        <td className={'label'} style={{width: '100%'}}>Land Use</td>
                    </tr>
                    <tr>
                        <td>
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'land_use')}
                                           parameters={this.state.landUsesOptions}/>
                        </td>
                    </tr>

                    </tbody>
                </table>

                <div style={{textAlign: 'center', width: '100%', float: 'left'}}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-search'}/>Search
                    </button>
                </div>

                <table className={'tb'} style={{width: '95%', margin: '2%', marginTop: '5%'}}>
                    <thead>
                    <tr>
                        <th>No.</th>
                        <th style={{position: 'sticky', left: 0}}>Land Use</th>
                        <th>Village</th>
                        <th>District</th>
                        <th>Area (Ha)</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.landuse.map((d, i) => {
                            return (<tr key={i}>
                                <td>{i + 1}
                                </td>
                                <td>
                                    <span style={{color: 'darkcyan'}}>{d.use}</span>
                                </td>
                                <td>{d.village}</td>
                                <td>{d.district}</td>
                                <td>{d.area}</td>
                            </tr>)
                        })
                    }

                    <tr>
                        <td className={'noHover'} colSpan={8} style={{textAlign: 'center'}}>
                            <button onClick={() => {
                                this.setState({
                                    pageSize: this.state.pageSize - 20
                                })
                                this.fetchProjectsByUrl(this.state.previous)
                            }} className={'btn default'}
                                    style={{visibility: this.state.previous !== null ? 'visible' : 'hidden'}}>Back
                            </button>
                            <b>{this.state.totalPages === 0 ? 0 : (this.state.pageSize) / 20}/{this.state.totalPages}</b>
                            <button onClick={() => {
                                this.setState({
                                    pageSize: this.state.pageSize + 20
                                })
                                this.fetchProjectsByUrl(this.state.next)
                            }} className={'btn default'}
                                    style={{visibility: this.state.next !== null ? 'visible' : 'hidden'}}>Next
                            </button>
                        </td>
                    </tr>

                    </tbody>
                </table>

            </div>

        </div>)
    }

    submit() {
        try {
            let land_use_id = this.state.land_use.value

            console.log('LU Type')
            console.log(land_use_id)

            Wait.show('Loading...')
            SpatialService.fetchLandUses(land_use_id).then(r => {
                Wait.dismiss()
                try {
                    let modules = []
                    r.data.results.forEach(d => modules.push(d))
                    console.log(r.data)
                    LandUsesPane.self.setState({
                        landuse: modules,
                        totalPages: 1,
                        next: null,
                        previous: null
                    })
                } catch (e) {
                    console.log(e)
                }

            })

        } catch (e) {
            alert(e)
        }
    }


    static getSeries(modules) {
        let series = []
        modules.map((d, i) => {
            let entry = {name: d.use, data: [Number(d.area)]}
            series.push(entry)
        })
        console.log(series)
        return {
            chart: {
                type: 'column'
            },

            title: {
                text: 'Land Use Plan per Hectare'
            },

            subtitle: {
                text: ''
            },

            yAxis: {
                title: {
                    text: 'Hectares'
                }
            },

            xAxis: {
                categories: ['Land Use'],
                crosshair: true
            },

            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle'
            },

            /* plotOptions: {
                 series: {
                     label: {
                         connectorAllowed: false
                     },
                     /!*pointStart: 2013*!/
                 }
             },
 */
            series: series,
            /* series: ,*/

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            }
        }
    }


}

